import { Plus, Trash2 } from "lucide-react";
import ImageUpload from "@/admin/components/ImageUpload";
import { Field, Text, Textarea, Select } from "@/admin/components/AdminField";

const CATS = [
  { value: "cafe", label: "Café" },
  { value: "restaurant", label: "Restaurante" },
  { value: "viewpoint", label: "Mirante" },
  { value: "hotel", label: "Hospedagem" },
  { value: "fuel", label: "Posto" },
  { value: "repair", label: "Oficina" },
  { value: "atrativo", label: "Atrativo" },
];

export default function POIEditor({ value = [], onChange }) {
  const set = (i, patch) => onChange(value.map((p, k) => (k === i ? { ...p, ...patch } : p)));
  const add = () => onChange([...value, { name: "", category: "cafe", description: "", address: "", google_url: "", rating: null, image: "" }]);
  const remove = (i) => onChange(value.filter((_, k) => k !== i));

  return (
    <div className="space-y-4" data-testid="poi-editor">
      {value.map((p, i) => (
        <div key={i} className="card-rotta p-5 bg-[#141414]" data-testid={`poi-row-${i}`}>
          <div className="flex items-center justify-between mb-4">
            <div className="font-display tracking-wider uppercase text-sm text-[#C6A762]">Ponto de Interesse #{i + 1}</div>
            <button type="button" onClick={() => remove(i)} className="w-8 h-8 grid place-items-center rounded-full text-[#B8B8B8] hover:text-red-400 hover:bg-red-500/10">
              <Trash2 size={14} />
            </button>
          </div>
          <div className="grid md:grid-cols-2 gap-4">
            <Field label="Nome">
              <Text value={p.name} onChange={(v) => set(i, { name: v })} placeholder="Café da Cleide" />
            </Field>
            <Field label="Categoria">
              <Select value={p.category} onChange={(v) => set(i, { category: v })} options={CATS} />
            </Field>
            <Field label="Endereço">
              <Text value={p.address} onChange={(v) => set(i, { address: v })} placeholder="Casa Branca, MG" />
            </Field>
            <Field label="Link Google Maps">
              <Text value={p.google_url} onChange={(v) => set(i, { google_url: v })} placeholder="https://maps.google.com/…" />
            </Field>
            <Field label="Nota (Google)">
              <Text
                type="number" step="0.1" min="0" max="5"
                value={p.rating ?? ""}
                onChange={(v) => set(i, { rating: v === "" ? null : parseFloat(v) })}
                placeholder="4.6"
              />
            </Field>
            <Field label="Imagem">
              <ImageUpload value={p.image} onChange={(url) => set(i, { image: url })} folder="rotta/pois" label="" />
            </Field>
            <Field label="Descrição" cols={2}>
              <Textarea value={p.description} onChange={(v) => set(i, { description: v })} rows={2} />
            </Field>
          </div>
        </div>
      ))}
      <button type="button" onClick={add} className="btn-ghost w-full py-4 rounded-xl text-xs inline-flex items-center justify-center gap-2">
        <Plus size={14} /> Adicionar ponto de interesse
      </button>
    </div>
  );
}
